import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';

const pageTitles = {
  '/admin/dashboard': { ne: 'ड्यासबोर्ड', en: 'Dashboard' },
  '/admin/sectors': { ne: 'क्षेत्रहरू', en: 'Sectors' },
  '/admin/events': { ne: 'कार्यक्रमहरू', en: 'Events' },
  '/admin/news': { ne: 'समाचार', en: 'News' },
  '/admin/downloads': { ne: 'डाउनलोड', en: 'Downloads' },
  '/admin/experts': { ne: 'विशेषज्ञहरू', en: 'Experts' },
  '/admin/volunteers': { ne: 'स्वयंसेवकहरू', en: 'Volunteers' },
  '/admin/contributions': { ne: 'योगदानहरू', en: 'Contributions' },
  '/admin/feedback': { ne: 'प्रतिक्रिया', en: 'Feedback' },
  '/admin/users': { ne: 'प्रयोगकर्ताहरू', en: 'Users' },
  '/admin/settings': { ne: 'सेटिङ', en: 'Settings' },
};

const AdminLayout = () => {
  const { language, toggleLanguage } = useLanguage();
  const { isAuthenticated, user, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="h-9 w-9 animate-spin rounded-full border-4 border-primary-100 border-t-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'admin') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream p-8">
        <div className="max-w-md rounded-3xl border border-char-100 bg-white p-8 text-center shadow-card">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-error-50">
            <svg className="h-8 w-8 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v2m0-2h2m-2 0H10m9.364-7.364A9 9 0 1112 3a9 9 0 017.364 4.636z" />
            </svg>
          </div>
          <h2 className="mb-2 text-xl font-extrabold text-char-900">
            {language === 'ne' ? 'पहुँच अस्वीकृत' : 'Access Denied'}
          </h2>
          <p className="mb-6 text-char-600">
            {language === 'ne'
              ? 'यो पृष्ठ केवल एडमिनहरूको लागि हो।'
              : 'This page is only accessible to administrators.'}
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-extrabold text-white shadow-green transition-all hover:-translate-y-0.5 hover:bg-primary-500 hover:shadow-green-hover"
          >
            {language === 'ne' ? 'गृहपृष्ठमा जानुहोस्' : 'Go to Homepage'}
          </a>
        </div>
      </div>
    );
  }

  const path = window.location.pathname;
  const titleObj = pageTitles[path] || { ne: 'ड्यासबोर्ड', en: 'Dashboard' };
  const title = titleObj[language] || titleObj.en;

  return (
    <div className="min-h-screen bg-cream">
      <AdminSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        language={language}
      />

      <div className="lg:pl-64">
        <AdminTopbar
          title={title}
          onToggleSidebar={() => setSidebarOpen(true)}
          language={language}
          onToggleLanguage={toggleLanguage}
        />

        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
